<template>
  <div style="height: 600px;overflow-y: auto">
    <div id="printBagNo" class="print">
      <div v-for="(item, index) in printData" :key="index" class="print-page">
        <img src="@/assets/img-logo.png" style="height: 100px;margin-bottom: 40px;" alt="">
        <div class="text-con">集货码-Código de armazenamento</div>
        <div class="bag_no">
          <div :id="'printBagNoSvg' + index" />
        </div>
        <div class="text-con">{{ item.code }}</div>
      </div>
    </div>
    <div id="img-logo" style="display: none;">
      <img src="@/assets/img-logo.png" style="height: 100px;margin-bottom: 40px;" alt="">
    </div>
  </div>
</template>
<script>
import qrcode from 'qrcode-generator';
import print from 'print-js';

export default {
  name: 'PrintWindow',
  props: {
    printData: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    console.log(this.printData, '===printData');
    this.$nextTick(() => {
      this.handlePrintConfirm();
    });
  },
  methods: {
    // 生成二维码
    handlePrintConfirm() {
      this.$nextTick(() => {
        this.printData.map((item, index) => {
          // 生成二维码
          const qr = qrcode(0, 'M');
          qr.addData(item.code);
          qr.make();
          const canvas = document.createElement('canvas');
          const size = 260;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          const cellSize = size / qr.getModuleCount();
          for (let row = 0; row < qr.getModuleCount(); row++) {
            for (let col = 0; col < qr.getModuleCount(); col++) {
              ctx.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
              ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
            }
          }
          document.getElementById('printBagNoSvg' + index).appendChild(canvas);
        });
      });
    },
    // 确认打印
    async confirmPrint() {
      print({
        printable: 'printBagNo', // // 文档来源：pdf或图像的url，html元素的id或json数据的对象
        type: 'html', // 可打印的类型。可用的打印选项包括：pdf，html，图像，json和raw-html。
        targetStyles: ['*'], // 库在打印HTML元素时处理任何样式
        font_size: ''
      });
    }
  }
};
</script>

<style scoped>
.print-page {
  page-break-after: always;
  break-after: page;
}
.bag_no {
  width: 100%;
  display: flex;
  justify-content: center;
}
.text-con {
  text-align: center;
  font-weight: bold;
  margin-bottom: 30px;
  margin-top: 20px;
  font-size: 28px;
}
</style>
